export interface Module {
  num: string
  title: string
  description: string
}

export const modules: Module[] = [
  {
    num: '1',
    title: 'Volleyball Practice Planning System™',
    description:
      'Stop starting every practice with a blank page. Use structured frameworks for 60, 75, 90, and 120-minute sessions, weekly schedules, technical and tactical priorities, pre-match and post-match practices, player organization, time allocation, coaching points, and reusable planning templates. Build organized sessions around what your team actually needs while dramatically reducing preparation time.',
  },
  {
    num: '2',
    title: 'Technical Drill & Progression Library™',
    description:
      'Access an organized professional library covering serving, serve receive, passing, setting, attacking, blocking, defense, coverage, transition, ball control, and communication. Each drill includes its objective, setup, execution, coaching points, common errors, success criteria, and adaptable progressions from easier versions through competitive situations.',
  },
  {
    num: '3',
    title: 'Ready-to-Coach Practice System™',
    description:
      'Open the system, choose your objective, and take a complete practice directly to the court. Work with ready-made sessions for serving pressure, reception, setting, attacking, blocking, defense, transition, side-out, communication, ball control, and competitive play. Each session provides objectives, sequence, timing, drills, progressions, coaching points, and competitive components.',
  },
  {
    num: '4',
    title: 'Game Situation & Tactical Training™',
    description:
      'Move beyond isolated drills and train situations that actually appear during competition. Develop serve-receive, side-out, transition offense, block-defense, coverage, out-of-system play, rotations, free-ball organization, decision-making, and end-game pressure through progressive game-like exercises, conditioned games, scoring systems, and competitive scenarios.',
  },
  {
    num: '5',
    title: 'Match Problem → Practice Solution™',
    description:
      'Turn what went wrong in the match into a clear plan for your next practice. Identify problems such as poor reception, serving errors, weak side-out efficiency, late blocking, defensive breakdowns, slow transitions, coverage issues, communication problems, or difficulty closing sets. Then follow structured priorities, drills, progressions, game-like solutions, and simple success metrics.',
  },
  {
    num: '6',
    title: 'Season & Team Performance System™',
    description:
      'Connect individual practices into an organized season. Structure pre-season, early season, competitive periods, tournament weeks, and end-of-season work with practical weekly models. Manage technical and tactical priorities, high and moderate-load sessions, pre-match and post-match practices, volleyball-specific preparation, player development, team progress, and coaching notes.',
  },
]

export const promises = [
  'Plan practices faster.',
  'Find the right drill for each objective.',
  'Use complete ready-to-coach sessions.',
  'Build logical technical progressions.',
  'Train real game situations.',
  'Turn match problems into practice solutions.',
  'Organize your team across the season.',
]
